import { createSelector } from 'reselect'
import { SimpleIndex } from '../common/simpleSearch'
import { indexBy } from 'lodash/fp'
import { ICycleCount } from '../types/cycle-counts'
import { ICycleCountsState } from './cycleCountsReducer'

interface IRootState {
  cycleCounts: ICycleCountsState
}

export const cycleCountsRootSelector = (state: IRootState) => state.cycleCounts

export const cycleCountsSelector = createSelector(
  cycleCountsRootSelector,
  (root) => root.cycleCounts,
)

export const currentCycleCountSelector = createSelector(
  cycleCountsRootSelector,
  (root) => root.currentCycleCount,
)

export const cycleCountsDictSelector = createSelector(
  cycleCountsSelector,
  (cycleCounts) => indexBy('id', cycleCounts),
)

export const cycleCountsSearchIndexSelector = createSelector(
  cycleCountsSelector,
  (cycleCounts) =>
    new SimpleIndex<ICycleCount>(cycleCounts, {
      keys: [
        (cc: ICycleCount) => cc.location?.code ?? '',
        (cc: ICycleCount) => cc.countedBy?.name ?? '',
      ],
    }),
)

export const cycleCountByIdSelector = (id: number) =>
  createSelector(cycleCountsDictSelector, (dict) => dict[id])
